import { SignalWatcher, WithDisposable } from '@blocksuite/affine/global/lit';
import { ShadowlessElement } from '@blocksuite/affine/std';
import type { TransformerMiddleware } from '@blocksuite/affine/store';
import type { TestAffineEditorContainer } from '@blocksuite/integration-test';
import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('custom-adapter-panel')
export class CustomAdapterPanel extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  static override styles = css`
    .custom-adapter-container {
      position: fixed;
      top: 0;
      right: 0;
      border: 1px solid var(--affine-border-color, #e3e2e4);
      background: var(--affine-background-overlay-panel-color, #ffffff);
      height: 100vh;
      width: 30vw;
      box-sizing: border-box;
      z-index: 1000;
      box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      color: var(--affine-text-primary-color, #000000);
      font-family: sans-serif;
    }
    .panel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid var(--affine-border-color, #e3e2e4);
      font-weight: 600;
      font-size: 16px;
    }
    .panel-close {
      cursor: pointer;
      font-size: 18px;
      opacity: 0.6;
    }
    .panel-close:hover {
      opacity: 1;
    }
    .panel-content {
      flex: 1;
      overflow-y: auto;
    }
  `;

  private _renderPanel() {
    return html`<affine-adapter-panel
      .store=${this.editor.doc}
      .transformerMiddlewares=${this.transformerMiddlewares}
    ></affine-adapter-panel>`;
  }

  override render() {
    return html`
      ${this._show
        ? html`
            <div class="custom-adapter-container">
              <div class="panel-header">
                <span>Adapter Panel</span>
                <span class="panel-close" @click=${() => this._show = false}>✕</span>
              </div>
              <div class="panel-content">
                ${this._renderPanel()}
              </div>
            </div>
          `
        : nothing}
    `;
  }

  toggleDisplay() {
    this._show = !this._show;
  }

  @state()
  private accessor _show = false;

  @property({ attribute: false })
  accessor editor!: TestAffineEditorContainer;

  @property({ attribute: false })
  accessor transformerMiddlewares: TransformerMiddleware[] = [];
}

declare global {
  interface HTMLElementTagNameMap {
    'custom-adapter-panel': CustomAdapterPanel;
  }
}
